// Core authentication types
export interface AuthUser {
  id: string;
  email?: string;
  user_metadata?: {
    full_name?: string;
    name?: string;
  };
}

export interface AuthContextType {
  user: AuthUser | null;
  loading: boolean;
  signOut: () => Promise<void>;
}

// Authentication state enum for clarity
export enum AuthState {
  LOADING = 'loading',
  AUTHENTICATED = 'authenticated', 
  UNAUTHENTICATED = 'unauthenticated'
}

export const getAuthState = (user: AuthUser | null, loading: boolean): AuthState => {
  if (loading) return AuthState.LOADING;
  return user ? AuthState.AUTHENTICATED : AuthState.UNAUTHENTICATED;
};